export default function SectionHeader({ eyebrow, title, lede, align = 'left', testid }) {
  return (
    <div data-testid={testid} className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-prim tracking-tighter leading-[1.05]">
        {title}
      </h2>
      {lede && <p className="mt-6 text-sec text-lg md:text-xl leading-relaxed max-w-2xl">{lede}</p>}
    </div>
  );
}
